import React from 'react';

import PageContent from '../../../components/pages/PageContent';
import TitlePage from '../../../components/common/TitlePage';

const PrivacyContainer = (props) => {
    return (
        <> 
            <section className="slw-sec">
                
                <TitlePage
                    heading={props.page.title}
                    text={props.page.sub_title}
                />
                
                <div className="container">
                    <div className="post-container fl-wrap">
                        <div className="row">
                            <div className="col-md-10 col-md-offset-1 col-sm-12 col-xs-12">
                                <PageContent
                                    content={props.page.contents}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default PrivacyContainer;